export default __webpack_public_path__ + "static/Office_image_1-f3cd5193d367f847b81265affea49539.png";